module.exports = __webpack_public_path__ + "img/pointer-black-thick.437a4b88.svg";